import * as React from "react"

import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../cn"

const dividerVariants = cva("shrink-0 bg-coval-border", {
  variants: {
    orientation: {
      horizontal: "h-px w-full",
      vertical: "w-px self-stretch",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
})

export interface DividerProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof dividerVariants> {}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ className, orientation: orientationProp, ...props }, ref) => {
    const orientation = orientationProp ?? "horizontal"
    return (
      <div
        ref={ref}
        role="separator"
        aria-orientation={orientation}
        className={cn(dividerVariants({ orientation, className }))}
        {...props}
      />
    )
  },
)

Divider.displayName = "Divider"

export { Divider, dividerVariants }
